module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SidebarSlider Widget

(function (fox, $) {
	"use strict";
	fox.registerWidget('SidebarSlider', {

		configure: function (argument) {
			this.isDefaultState = true;

			this.registerOptions('', {
				targetSelector: '.part-navigator',
				targetWidget: '@parent'
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.offset = this.requireOption('scrollOffset');
			this.bottomOffset = this.getOption('bottomScrollOffset') || 45;
			this.targetWidget = this.wom1(this.requireOption('targetWidget'));

			if (!this.targetWidget) {
				return;
			}

			this.handleEvent(this.targetWidget, 'addedToDom', this.getElement);

			this.callParent('init', arguments);
		},

		running: function () {
			$(window).on('scroll', {widget: this}, this._handleSlide);
		},

		/*activate: function () {
			$(window).on('scroll', {widget: this}, this._handleSlide);

			this.callParent('activate', arguments);
		},

		deactivate: function () {
			$(window).off('scroll', this._handleSlide);
			this.isDefaultState = true;

			this.callParent('deactivate', arguments);
		},*/

		_handleSlide: function (e) {
			var widget = e.data.widget;
			var top = widget.getPageOffset();
			var pageHeight = $('body > div').eq(0).height();
			var winHeight = $(window).height();

			widget.dispatchEvent('scrolling', {top: top});

			if (widget.isDefaultState) {
				if (top >= widget.offset) {
					widget.isDefaultState = false;
					widget.dispatchEvent('slideStart');
					widget.hookWrapper('slideStart');

					return;
				}

				return;
			}

			if (top < widget.offset) {
				widget.isDefaultState = true;
				widget.dispatchEvent('slideEnd');
				widget.hookWrapper('slideEnd');
			}

			if (!widget.bottomOffset) {
				return;
			}

			if (widget.isBottomReached) {
				if ((pageHeight - top - $(window).height()) > widget.bottomOffset) {
					//console.warn('bottomOffsetPassed');

					widget.isBottomReached = false;
					widget.dispatchEvent('bottomOffsetPassed');
					widget.hookWrapper('bottomOffsetPassed');
				}

				return;
			}

			if ((pageHeight - top - $(window).height()) <= widget.bottomOffset) {
				widget.isBottomReached = true;
				widget.dispatchEvent('bottomOffsetReached');
				widget.hookWrapper('bottomOffsetReached');
			}
		},

		getElement: function (obj, w, alias) {
			this.slidableElement = w.dom(this.requireOption('targetSelector'));

			fox.each(this.slidableElement, function (elm) {
				fox.dom.addClass('fox-sidebar', elm);
			});

			this._handleSlide({data: {widget: this}});
		},

		getElementHeight: function() {
			return $(this.requireOption('targetSelector')).outerHeight(true);
		},

		getPageOffset: function () {
			return window.scrollY || window.pageYOffset; // window.pageYOffset for IE
		},

		slideStart: function () {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);
				var mainContainer = $('#mc-page-container');
				if ($(window).height() > elm.height() && elm.height() < mainContainer.height()){
					elm.addClass('slide');
					elm.css('width', elm.parent().width());
				}
			});
		},

		slideEnd: function () {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);
				if (elm.hasClass('slide')){
					elm.removeClass('slide');
					elm.css('width', '');
				}
			});
		},

		bottomOffsetReached: function (argument) {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);

				if (elm.height() >  $(window).height()) {
					elm.addClass('stick-to-bottom');
				}

				elm.addClass('bottom-reached');
			});
		},

		bottomOffsetPassed: function (argument) {
			fox.each(this.slidableElement, function (elm) {
				elm = $(elm);

				if (elm.height() >  $(window).height()) {
					elm.removeClass('stick-to-bottom');
				}

				elm.removeClass('bottom-reached');
			});
		},

		setOffset: function (offset) {
			this.offset = offset;
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/sidebarSlider.js
// module id = 53
// module chunks = 5